// Copyright (c) 2016 Deere & Company

import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import PipIndicator, {getDefaultState as getPipIndicatorDefaultState} from './pip-indicator';
import t from 'tcomb';

const TransferProduct = t.struct({
    baseMachineCode: t.String,
    customerSummary: CustomerSummary,
    imageUrl: t.String,
    model:t.maybe(t.String),
    pin: t.String,
    pip: t.String,
    pipIndicator: PipIndicator
}, {
    name: 'TransferProduct',
    strict: true
});

export const getDefaultState = () => new TransferProduct({
    baseMachineCode: '',
    customerSummary: getCustomerSummaryDefaultState(),
    imageUrl: '',
    pin: '',
    pip: 'NONE',
    pipIndicator: getPipIndicatorDefaultState()
});

export default TransferProduct;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/transfer-product.js